import React from "react";

import { useMediaQuery } from 'react-responsive';
import Dialog from '@mui/material/Dialog';
import DialogContent from '@mui/material/DialogContent';

import PlaceForm from './place-form';

export default function PlaceCreationForm( { open, onCancel, onCreated, rootCategory, initialPlace, options} ) {

	const isMedium = useMediaQuery({ query: `(max-width: 900px)` });

	return(
	 	<Dialog open={open} fullWidth maxWidth="lg" fullScreen={isMedium}>
	        <DialogContent style={{ paddingTop: '16px', paddingBottom: '16px' }}>
	        	<PlaceForm fullWidth rootCategory={rootCategory} onCancel={onCancel} onSave={onCreated} initialPlace={initialPlace} options={{...options, photos:'hidden'}} />
	        </DialogContent>
      	</Dialog>
	)

}